import { jsx as _jsx } from "react/jsx-runtime";
import { Message } from '@wegic/ui';
import '@wegic/ui/dist/components/Message/index.css';
import classNames from 'classnames';
import { copyToClipboard } from '@/utils';
import styles from './index.module.less';
export const markdownComponents = {
    /**
   * 行内 code 点击复制：
   * 通过 className 是否含 `language-` 或原文是否多行来识别 fenced 代码块。
   */ code (param) {
        let { node, className, children, ...rest } = param;
        const raw = String(children ?? '');
        const isFenced = /\blanguage-/.test(className || '') || raw.includes('\n');
        if (isFenced) {
            return /*#__PURE__*/ _jsx("code", {
                className: className,
                ...rest,
                children: children
            });
        }
        const text = raw.replace(/\n$/, '');
        const handleCopy = ()=>{
            if (!text) {
                return;
            }
            void copyToClipboard(text).then(()=>Message.success(intl.get('common.message.copiedToClipboard')), ()=>Message.error(intl.get('common.error.copyFailed')));
        };
        const handleKeyDown = (e)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleCopy();
            }
        };
        return /*#__PURE__*/ _jsx("code", {
            className: classNames(className, styles['inline-code-copy']),
            role: "button",
            tabIndex: 0,
            title: intl.get('common.action.copy'),
            onClick: handleCopy,
            onKeyDown: handleKeyDown,
            ...rest,
            children: children
        });
    }
};
